import { DeleteConfirmationModal } from '@/shared/ui/delete-confirmation-modal';
import { ImageViewerModal } from '@/shared/ui/image-viewer-modal';

/**
 * Global modals that should be available throughout the entire application
 */
export const GlobalModals = () => {
  return (
    <>
      <DeleteConfirmationModal />
      <ImageViewerModal />
    </>
  );
};
